module.exports = __webpack_public_path__ + "static/media/stats1960.c6bfc04d.jpg";